<!-- 车辆操作 -->
<template>
  <div class="demo-drawer__content data_action_form">
    <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
      <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}">
        <template slot="tabs" slot-scope="scope">
          <div v-if="scope.index==0">
            <el-form size="mini" id="mainInfo" label-width="120px">
              <el-row>
                <el-form-item label="车牌号" prop="vmLicensecode">
                  <el-input v-model.trim="sendDataInfo.vmLicensecode" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="车架号">
                  <el-input v-model.trim="sendDataInfo.vmVinno" maxlength="64"></el-input>
                </el-form-item>
                <el-form-item label="品牌">
                  <el-input v-model.trim="sendDataInfo.vmBrand" maxlength="64"></el-input>
                </el-form-item>
                <el-form-item label="颜色">
                  <el-input v-model.trim="sendDataInfo.vmColor" :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
                <el-form-item label="购买时间">
                  <el-date-picker v-model="sendDataInfo.vmBuytime" value-format="timestamp" style="width: 100%;" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="年检时间">
                  <el-date-picker v-model="sendDataInfo.vmInspectiontime" value-format="timestamp" style="width: 100%;" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="生产商">
                  <el-input v-model.trim="sendDataInfo.vmProducer"></el-input>
                </el-form-item>
                <el-form-item label="供货商">
                  <el-input v-model.trim="sendDataInfo.vmSupplier"></el-input>
                </el-form-item>
                <el-form-item label="车辆类别">
                  <el-radio-group v-model="sendDataInfo.vmType">
                    <el-radio-button label="1">办公车辆</el-radio-button>
                    <el-radio-button label="0">配送车辆</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-row>
            </el-form>
          </div>
        </template>
      </v-tabs>
    </el-card>
    <div class="foots">
      <el-button type="primary" @click="initActionBox">取消</el-button>
      <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
      <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: 'carAction',
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showTabs: "",
      tabForm: [],
      dataActionBox: {
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        vmBrand: '',   // 品牌
        vmBuytime: '',   // 	购买时间
        vmColor: '',   // 	颜色
        vmCreater: '',   // 创建人
        vmInspectiontime: '',   // 年检时间
        vmLicensecode: '',   // 车牌号
        vmProducer: '',   // 生成商
        vmSupplier: '',   // 供货商
        vmVinno: '',   // 车架号
        vmId: "",
        vmType: "1", //车辆类型 0配送、1办公
      },

    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    initActionBox() {
      this.$emit("drawerCancel");
      this.init();
    },
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = ''
      }
      this.sendDataInfo.vmInspectiontime = this.$moment().valueOf();
      this.sendDataInfo.vmBuytime = this.$moment().valueOf()
      this.sendDataInfo.vmType = "1"
    },
    openBox() {
      this.init()
      if (this.actionData.cate == 0) {
        this.dataActionBox.boxTitle = '新增车辆信息'
      } else {
        this.dataActionBox.boxTitle = '编辑车辆信息'
        for (let key in this.actionData.oldData) {
          this.sendDataInfo[key] = this.actionData.oldData[key]
        }
      }
      this.showTabs = this.dataActionBox.boxTitle
      this.tabForm = [
        {
          jciName: this.dataActionBox.boxTitle,
          jurconfigform: [],
        }
      ]
      this.dataActionBox.actionType = this.actionData.cate
    },
    async sendDataAction() {
      if (this.sendDataInfo.vmLicensecode == '') {
        this.$message({
          message: '请填写车牌号',
          type: 'error'
        });
        return false
      }

      if (this.sendDataInfo.vmBuytime == '') {
        this.$message({
          message: '请选择购买时间',
          type: 'error'
        });
        return false
      }

      if (this.sendDataInfo.vmInspectiontime == '') {
        this.$message({
          message: '请选择年检时间',
          type: 'error'
        });
        return false
      }
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.addCarInfo(this.sendDataInfo)
      } else {
        var responseData = await this.$http.editCarInfo(this.sendDataInfo)
      }


      if (responseData.status == 200) {
        this.$emit("drawerCancel", true);
        this.init()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },



  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.openBox()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
#mainInfo {
  padding-bottom: 10px;
}
</style>